export default "__VITE_ASSET__q1GN2J6$__"